<template>
  <div id="experience">
    <div class="container">
      <h1 class="myTitle-white">Experience</h1>
      <!-- 天堂遊戲 -->
      <div class="row d-flex justify-content-center py-4">
        <div class="col-md-3 justify-content-md-end d-none d-md-flex">
          <div class="position-relative exInner">
            <img class="img-fluid exImg" src="../assets/experience/iconfinder_Notebook_by_Artdesigner_60879.png"
              alt="img">
            <div class="exLine"></div>
          </div>
        </div>
        <div class="col-md-8">
          <div class="exContent text-white">
            <h4 class="pb-4">天堂遊戲 | 前端工程師 | <span class="d-inline-block"><i class="fas fa-clock"></i> 2020 年 3 月 - 在職</span></h4>
            <p style="font-weight: 500; font-size: 20px;">▼ Milestone：</p>
            <p style="line-height: 32px;">
              ◎ 漸進式重構 Knockout 至 Vue 框架，達成前後端分離。<br>
              ◎ 新專案導入 Vue3 配上 Vite 打包環境，節省開發時間及優化前端效能。<br>
              ◎ 聊天系統引入 TypeScript 固定各類訊息格式，並有效利用 VS Code 工具提示。<br>
              ◎ 為聊天系統實作片段緩存機制，提升顯示效能及減少網路流量。<br>
              ◎ 協助團隊導入單元測試並達成 85％ 以上覆蓋率.<br>
              ◎ CI/CD 腳本建置及 dockerfile layer 優化。<br>
              ◎ 引入 i18n 並實作語言json包／後端文案整合／部分語系拆分客製化樣板。<br>
              ◎ 實作智能客服流程圖形化設定介面，提升使用直覺感。<br>
              ◎ 整合 Jira API 來客製化任務工時顯示介面。<br>
            </p>
            <p style="font-weight: 500; font-size: 20px;">▼ Responsible for：</p>
            <p><i class="fas fa-tools pr-3"></i> 即時通訊平台</p>
            <p>core tech：Vue3／TypeScript／Pinia／Vite／Docker／Jenkins</p>
            <p><i class="fas fa-tools pr-3"></i> 客服系統</p>
            <p>core tech：Vue／Vuex／Element UI／Jest／i18n／Webpack／Docker／Rancher</p>
            <p><i class="fas fa-tools pr-3"></i> Jira 工單管理系統</p>
            <p>core tech：Vue／Antd UI／Echarts／Webpack／Docker／Rancher</p>
            <p><i class="fas fa-tools pr-3"></i> 彩票開獎網</p>
            <p>core tech：Nuxt／Linux／Echarts／Canvas</p>
            <p><i class="fas fa-tools pr-3"></i> 彩票官網、後台</p>
            <p>core tech：Knockout／Golang／Vue／Linux／Jenkins</p>
          </div>
        </div>
      </div>
      <!-- 雲中雲 -->
      <div class="row d-flex justify-content-center py-4">
        <div class="col-md-3 justify-content-md-end d-none d-md-flex">
          <div class="position-relative exInner">
            <img class="img-fluid exImg" src="../assets/experience/iconfinder_Notebook_by_Artdesigner_60879.png"
              alt="img">
            <div class="exLine"></div>
          </div>
        </div>
        <div class="col-md-8">
          <div class="exContent text-white">
            <h4 class="pb-4">雲中雲 | 前端工程師 | <span class="d-inline-block"><i class="fas fa-clock"></i> 2019 年 11 月 - 2020 年 1 月</span></h4>
            <p><i class="fas fa-tools pr-3"></i> 彩票前台跨框架重構</p>
            <p><i class="fas fa-tools pr-3"></i> 彩票後台新功能開發</p>
            <p>在任職期間研究並開始使用 React 框架，主要負責重構彩票前台 React 轉成 Vue 架構，充分熟悉 UI 元件的客製化及架 jsx 的語法差異。</p>
          </div>
        </div>
      </div>
      <!-- thinkpower -->
      <div class="row d-flex justify-content-center py-4">
        <div class="col-md-3 justify-content-md-end d-none d-md-flex">
          <div class="position-relative exInner">
            <img class="img-fluid exImg" src="../assets/experience/iconfinder_Notebook_by_Artdesigner_60879.png"
              alt="img">
            <div class="exLine"></div>
          </div>
        </div>
        <div class="col-md-8">
          <div class="exContent text-white">
            <h4 class="pb-4">昕力資訊 | 前端工程師 | <span class="d-inline-block"><i class="fas fa-clock"></i> 2019 年 2 月 - 2019 年 10 月</span></h4>
            <p><i class="fas fa-tools pr-3"></i> 串接後端 Java RESTful API</p>
            <p><i class="fas fa-tools pr-3"></i> 與設計部門協調 UI/UX 邏輯</p>
            <p><i class="fas fa-tools pr-3"></i> 解決瀏覽器與裝置的相容問題</p>
            <p><i class="fas fa-tools pr-3"></i> 測試資料 mock 建置</p>
            <p>主要負責客戶關係管理專案前端 Vue.js，依照客戶 SPEC 串接後端 API 、撰寫前端邏輯、向設計師溝通調整 UI/UX layout。</p>
          </div>
        </div>
      </div>
      <!-- 國立虎尾科技大學 -->
      <div class="row d-flex justify-content-center py-4">
        <div class="col-md-3 justify-content-md-end d-none d-md-flex">
          <div class="position-relative exInner">
            <img class="img-fluid exImg" src="../assets/experience/Graduation.png" alt="img">
          </div>
        </div>
        <div class="col-md-8">
          <div class="exContent text-white">
            <h4 class="pb-4">國立虎尾科技大學 | 工業工程管理 | <span class="d-inline-block"><i class="fas fa-clock"></i> 2010 年 6 月
                畢業</span></h4>
            <p><i class="fas fa-tools pr-3"></i> 畢業聯誼會-名人演講講座策劃：</p>
            <p>當時向經紀公司請了陳漢典來學校，我必須在校務跟經紀公司之間做好溝通的橋樑，協調演講費部分的定案，讓經紀公司可以接受且校務局的合理，在這過程去提升我的協調能力。</p>
            <p><i class="fas fa-tools pr-3"></i> 吉他社-社團期末發表總召：</p>
            <p>負責活動人員的安排、活動流程制定、場地選擇與探勘、拜訪周邊商家提供活動贊助。</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MyExperience',
  props: {
    
  }
}
</script>

<style lang="scss" scoped>
</style>
